import { jsx as _jsx } from "react/jsx-runtime";
import { Column } from '~/views/atoms/boxes';
import { FormikRadioGroup } from '~/views/atoms/formik-radio-group';
import { useFormikContext } from 'formik';
export const FormDateFilter = ({ options }) => {
    const formik = useFormikContext();
    return (_jsx(Column, { gap: 2, children: _jsx(FormikRadioGroup, { options: options, formikProps: formik, name: 'filterOption', defaultValue: formik.initialValues.filterOption }) }));
};
